/** Drawer (MyPage) + business dashboard overlays for non-ko/en base locales */

const mp = (o) => ({ myPage: o });
const full = (myPage, extra = {}) => ({ ...mp(myPage), ...extra });

export const DRAWER_UI = {
  'zh-CN': full(
    {
      following: '关注',
      followers: '粉丝',
      statsPoints: '积分',
      statsTrades: '交易',
      statsReviews: '评价',
      statsNoShow: '爽约',
      myTrades: '我的交易',
      myReservations: '预约记录',
      myFavorites: '收藏',
      myReviews: '我的评价',
      invite: '邀请好友',
      inviteCopied: '邀请码已复制',
      adCta: '为您的店铺做广告！',
      menu: {
        notificationSettings: '通知设置',
        language: '语言',
        region: '地区',
        businessDashboard: '商户中心',
        mingoEvents: 'Mingo 活动',
        exchangeRates: '汇率',
      },
    },
    {
      expiry: { menuLabel: '到期提醒' },
      story: { revenueMenuLabel: '故事收益' },
      translation: { menuLabel: '内容翻译' },
      location: { radiusMenuLabel: '位置半径' },
      privacy: { title: '隐私政策' },
      terms: { title: '服务条款' },
      points: { charge: '充值' },
      dashboard: {
        title: '商户中心',
        noBusiness: '暂无注册商户',
        emptyRegisterLead: '请先注册商户后使用。',
        tabsAria: '商户中心标签',
        selectBusiness: '选择商户',
      },
      biz: {
        tabOverview: '概览',
        tabManage: '管理',
        tabAds: '广告',
        tabShorts: '短视频',
        tabPlan: '套餐',
      },
      life: { registerFromEmpty: '注册商户' },
      adSlot: { defaultCta: '💡 您的店铺也可以在此投放广告！' },
    },
  ),
  'zh-TW': full(
    {
      following: '追蹤中',
      followers: '粉絲',
      statsPoints: '積分',
      statsTrades: '交易',
      statsReviews: '評價',
      statsNoShow: '爽約',
      myTrades: '我的交易',
      myReservations: '預約紀錄',
      myFavorites: '收藏',
      myReviews: '我的評價',
      invite: '邀請好友',
      inviteCopied: '邀請碼已複製',
      adCta: '為您的店家打廣告！',
      menu: {
        notificationSettings: '通知設定',
        language: '語言',
        region: '地區',
        businessDashboard: '商家中心',
        mingoEvents: 'Mingo 活動',
        exchangeRates: '匯率',
      },
    },
    {
      expiry: { menuLabel: '到期提醒' },
      story: { revenueMenuLabel: '故事收益' },
      translation: { menuLabel: '內容翻譯' },
      location: { radiusMenuLabel: '位置半徑' },
      privacy: { title: '隱私權政策' },
      terms: { title: '服務條款' },
      points: { charge: '儲值' },
      dashboard: {
        title: '商家中心',
        noBusiness: '尚未註冊商家',
        emptyRegisterLead: '請先註冊商家後再使用。',
        tabsAria: '商家中心分頁',
        selectBusiness: '選擇商家',
      },
      biz: {
        tabOverview: '總覽',
        tabManage: '管理',
        tabAds: '廣告',
        tabShorts: '短影片',
        tabPlan: '方案',
      },
      life: { registerFromEmpty: '註冊商家' },
      adSlot: { defaultCta: '💡 您的店家也可以在這裡投放廣告！' },
    },
  ),
  ja: full(
    {
      following: 'フォロー中',
      followers: 'フォロワー',
      statsPoints: 'ポイント',
      statsTrades: '取引',
      statsReviews: 'レビュー',
      statsNoShow: 'ドタキャン',
      myTrades: 'マイトレード',
      myReservations: '予約履歴',
      myFavorites: 'お気に入り',
      myReviews: 'マイレビュー',
      invite: '友達を招待',
      inviteCopied: '招待コードをコピーしました',
      adCta: 'お店を宣伝しましょう！',
      menu: {
        notificationSettings: '通知設定',
        language: '言語',
        region: '地域',
        businessDashboard: '店舗ダッシュボード',
        mingoEvents: 'Mingoイベント',
        exchangeRates: '為替レート',
      },
    },
    {
      expiry: { menuLabel: '期限リマインダー' },
      story: { revenueMenuLabel: 'ストーリー収益' },
      translation: { menuLabel: 'コンテンツ翻訳' },
      location: { radiusMenuLabel: '位置半径' },
      privacy: { title: 'プライバシーポリシー' },
      terms: { title: '利用規約' },
      points: { charge: 'チャージ' },
      dashboard: {
        title: '店舗ダッシュボード',
        noBusiness: '登録された店舗がありません',
        emptyRegisterLead: '店舗登録後にご利用ください。',
        tabsAria: '店舗ダッシュボードタブ',
        selectBusiness: '店舗を選択',
      },
      biz: {
        tabOverview: '概要',
        tabManage: '管理',
        tabAds: '広告',
        tabShorts: 'ショート',
        tabPlan: 'プラン',
      },
      life: { registerFromEmpty: '店舗を登録' },
      adSlot: { defaultCta: '💡 お店もここで宣伝できます！' },
    },
  ),
  th: full(
    {
      following: 'กำลังติดตาม',
      followers: 'ผู้ติดตาม',
      statsPoints: 'คะแนน',
      statsTrades: 'การซื้อขาย',
      statsReviews: 'รีวิว',
      statsNoShow: 'ไม่มา',
      myTrades: 'การซื้อขายของฉัน',
      myReservations: 'ประวัติการจอง',
      myFavorites: 'รายการโปรด',
      myReviews: 'รีวิวของฉัน',
      invite: 'ชวนเพื่อน',
      inviteCopied: 'คัดลอกรหัสเชิญแล้ว',
      adCta: 'โฆษณาร้านของคุณ!',
      menu: {
        notificationSettings: 'การแจ้งเตือน',
        language: 'ภาษา',
        region: 'ภูมิภาค',
        businessDashboard: 'แดชบอร์ดร้าน',
        mingoEvents: 'กิจกรรม Mingo',
        exchangeRates: 'อัตราแลกเปลี่ยน',
      },
    },
    {
      expiry: { menuLabel: 'แจ้งเตือนหมดอายุ' },
      story: { revenueMenuLabel: 'รายได้ Story' },
      translation: { menuLabel: 'แปลเนื้อหา' },
      location: { radiusMenuLabel: 'รัศมีตำแหน่ง' },
      privacy: { title: 'นโยบายความเป็นส่วนตัว' },
      terms: { title: 'ข้อกำหนดการใช้งาน' },
      points: { charge: 'เติมเงิน' },
      dashboard: {
        title: 'แดชบอร์ดร้าน',
        noBusiness: 'ยังไม่มีร้านที่ลงทะเบียน',
        emptyRegisterLead: 'กรุณาลงทะเบียนร้านก่อนใช้งาน',
        tabsAria: 'แท็บแดชบอร์ดร้าน',
        selectBusiness: 'เลือกร้าน',
      },
      biz: {
        tabOverview: 'ภาพรวม',
        tabManage: 'จัดการ',
        tabAds: 'โฆษณา',
        tabShorts: 'ชอร์ต',
        tabPlan: 'แพ็กเกจ',
      },
      life: { registerFromEmpty: 'ลงทะเบียนร้าน' },
      adSlot: { defaultCta: '💡 ร้านของคุณโฆษณาที่นี่ได้!' },
    },
  ),
  vi: full(
    {
      following: 'Đang theo dõi',
      followers: 'Người theo dõi',
      statsPoints: 'Điểm',
      statsTrades: 'Giao dịch',
      statsReviews: 'Đánh giá',
      statsNoShow: 'Không đến',
      myTrades: 'Giao dịch của tôi',
      myReservations: 'Lịch đặt',
      myFavorites: 'Yêu thích',
      myReviews: 'Đánh giá của tôi',
      invite: 'Mời bạn bè',
      inviteCopied: 'Đã sao chép mã mời',
      adCta: 'Quảng cáo cửa hàng của bạn!',
      menu: {
        notificationSettings: 'Cài đặt thông báo',
        language: 'Ngôn ngữ',
        region: 'Khu vực',
        businessDashboard: 'Bảng điều khiển cửa hàng',
        mingoEvents: 'Sự kiện Mingo',
        exchangeRates: 'Tỷ giá',
      },
    },
    {
      expiry: { menuLabel: 'Nhắc hạn dùng' },
      story: { revenueMenuLabel: 'Doanh thu Story' },
      translation: { menuLabel: 'Dịch nội dung' },
      location: { radiusMenuLabel: 'Bán kính vị trí' },
      privacy: { title: 'Chính sách bảo mật' },
      terms: { title: 'Điều khoản dịch vụ' },
      points: { charge: 'Nạp điểm' },
      dashboard: {
        title: 'Bảng điều khiển cửa hàng',
        noBusiness: 'Chưa có cửa hàng đăng ký',
        emptyRegisterLead: 'Vui lòng đăng ký cửa hàng trước khi sử dụng.',
        tabsAria: 'Tab bảng điều khiển',
        selectBusiness: 'Chọn cửa hàng',
      },
      biz: {
        tabOverview: 'Tổng quan',
        tabManage: 'Quản lý',
        tabAds: 'Quảng cáo',
        tabShorts: 'Shorts',
        tabPlan: 'Gói',
      },
      life: { registerFromEmpty: 'Đăng ký cửa hàng' },
      adSlot: { defaultCta: '💡 Cửa hàng của bạn cũng quảng cáo tại đây!' },
    },
  ),
  ru: full(
    {
      following: 'Подписки',
      followers: 'Подписчики',
      statsPoints: 'Баллы',
      statsTrades: 'Сделки',
      statsReviews: 'Отзывы',
      statsNoShow: 'Неявки',
      myTrades: 'Мои сделки',
      myReservations: 'Бронирования',
      myFavorites: 'Избранное',
      myReviews: 'Мои отзывы',
      invite: 'Пригласить друзей',
      inviteCopied: 'Код приглашения скопирован',
      adCta: 'Рекламируйте свой бизнес!',
      menu: {
        notificationSettings: 'Уведомления',
        language: 'Язык',
        region: 'Регион',
        businessDashboard: 'Панель бизнеса',
        mingoEvents: 'События Mingo',
        exchangeRates: 'Курсы валют',
      },
    },
    {
      expiry: { menuLabel: 'Напоминание о сроке' },
      story: { revenueMenuLabel: 'Доход Story' },
      translation: { menuLabel: 'Перевод контента' },
      location: { radiusMenuLabel: 'Радиус местоположения' },
      privacy: { title: 'Политика конфиденциальности' },
      terms: { title: 'Условия использования' },
      points: { charge: 'Пополнить' },
      dashboard: {
        title: 'Панель бизнеса',
        noBusiness: 'Нет зарегистрированных заведений',
        emptyRegisterLead: 'Зарегистрируйте заведение, чтобы продолжить.',
        tabsAria: 'Вкладки панели бизнеса',
        selectBusiness: 'Выберите заведение',
      },
      biz: {
        tabOverview: 'Обзор',
        tabManage: 'Управление',
        tabAds: 'Реклама',
        tabShorts: 'Шорты',
        tabPlan: 'План',
      },
      life: { registerFromEmpty: 'Зарегистрировать' },
      adSlot: { defaultCta: '💡 Ваш бизнес может рекламироваться здесь!' },
    },
  ),
  id: full(
    {
      following: 'Mengikuti',
      followers: 'Pengikut',
      statsPoints: 'Poin',
      statsTrades: 'Transaksi',
      statsReviews: 'Ulasan',
      statsNoShow: 'Tidak hadir',
      myTrades: 'Transaksi saya',
      myReservations: 'Riwayat reservasi',
      myFavorites: 'Favorit',
      myReviews: 'Ulasan saya',
      invite: 'Undang teman',
      inviteCopied: 'Kode undangan disalin',
      adCta: 'Iklankan bisnis Anda!',
      menu: {
        notificationSettings: 'Pengaturan notifikasi',
        language: 'Bahasa',
        region: 'Wilayah',
        businessDashboard: 'Dasbor bisnis',
        mingoEvents: 'Acara Mingo',
        exchangeRates: 'Kurs',
      },
    },
    {
      expiry: { menuLabel: 'Pengingat kedaluwarsa' },
      story: { revenueMenuLabel: 'Pendapatan Story' },
      translation: { menuLabel: 'Terjemahan konten' },
      location: { radiusMenuLabel: 'Radius lokasi' },
      privacy: { title: 'Kebijakan privasi' },
      terms: { title: 'Ketentuan layanan' },
      points: { charge: 'Isi ulang' },
      dashboard: {
        title: 'Dasbor bisnis',
        noBusiness: 'Belum ada bisnis terdaftar',
        emptyRegisterLead: 'Daftarkan bisnis Anda terlebih dahulu.',
        tabsAria: 'Tab dasbor bisnis',
        selectBusiness: 'Pilih bisnis',
      },
      biz: {
        tabOverview: 'Ringkasan',
        tabManage: 'Kelola',
        tabAds: 'Iklan',
        tabShorts: 'Shorts',
        tabPlan: 'Paket',
      },
      life: { registerFromEmpty: 'Daftar bisnis' },
      adSlot: { defaultCta: '💡 Bisnis Anda bisa beriklan di sini!' },
    },
  ),
  hi: full(
    {
      following: 'फ़ॉलोइंग',
      followers: 'फ़ॉलोअर्स',
      statsPoints: 'पॉइंट्स',
      statsTrades: 'ट्रेड',
      statsReviews: 'समीक्षाएँ',
      statsNoShow: 'नो-शो',
      myTrades: 'मेरे ट्रेड',
      myReservations: 'बुकिंग इतिहास',
      myFavorites: 'पसंदीदा',
      myReviews: 'मेरी समीक्षाएँ',
      invite: 'मित्र आमंत्रित करें',
      inviteCopied: 'आमंत्रण कोड कॉपी हुआ',
      adCta: 'अपने व्यवसाय का विज्ञापन करें!',
      menu: {
        notificationSettings: 'सूचना सेटिंग',
        language: 'भाषा',
        region: 'क्षेत्र',
        businessDashboard: 'व्यवसाय डैशबोर्ड',
        mingoEvents: 'Mingo इवेंट',
        exchangeRates: 'विनिमय दर',
      },
    },
    {
      expiry: { menuLabel: 'समाप्ति अनुस्मारक' },
      story: { revenueMenuLabel: 'स्टोरी राजस्व' },
      translation: { menuLabel: 'सामग्री अनुवाद' },
      location: { radiusMenuLabel: 'स्थान त्रिज्या' },
      privacy: { title: 'गोपनीयता नीति' },
      terms: { title: 'सेवा की शर्तें' },
      points: { charge: 'रिचार्ज' },
      dashboard: {
        title: 'व्यवसाय डैशबोर्ड',
        noBusiness: 'कोई पंजीकृत व्यवसाय नहीं',
        emptyRegisterLead: 'उपयोग से पहले व्यवसाय पंजीकृत करें।',
        tabsAria: 'डैशबोर्ड टैब',
        selectBusiness: 'व्यवसाय चुनें',
      },
      biz: {
        tabOverview: 'अवलोकन',
        tabManage: 'प्रबंधन',
        tabAds: 'विज्ञापन',
        tabShorts: 'शॉर्ट्स',
        tabPlan: 'योजना',
      },
      life: { registerFromEmpty: 'व्यवसाय पंजीकृत करें' },
      adSlot: { defaultCta: '💡 आपका व्यवसाय यहाँ विज्ञापन कर सकता है!' },
    },
  ),
  ko: {
    myPage: { myReservations: '예약 내역' },
    dashboard: {
      emptyRegisterLead: '등록된 업체가 없습니다. 업체 등록 후 이용해 주세요.',
      tabsAria: '업체 대시보드 탭',
      selectBusiness: '업체 선택',
    },
    adSlot: { defaultCta: '💡 내 업체도 여기 광고할 수 있어요!' },
  },
  en: {
    myPage: { myReservations: 'My bookings' },
    dashboard: {
      emptyRegisterLead: 'No registered businesses yet. Register a business to continue.',
      tabsAria: 'Business dashboard tabs',
      selectBusiness: 'Select business',
    },
    adSlot: { defaultCta: '💡 Your business can advertise here too!' },
  },
};
